import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useQuery } from '@tanstack/react-query';

export const GET_ORDER_LISTING_QUERY_KEY = ['order.listing'];

export const useOrderListing = ({ orderId }: { orderId: string }) => {
  const { data: orderListing } = useQuery({
    queryKey: [...GET_ORDER_LISTING_QUERY_KEY, orderId],
    queryFn: async () => await OrdersClient.findOrderListing(orderId),
    enabled: !!orderId,
  });

  return {
    orderListing,
  };
};
